<template>
  <Frontendlayout>
    <section class="hero_in general">
			<div class="wrapper">
				<div class="container">
					<h1 class="fadeInUp"><span></span>Requirements</h1>
				</div>
			</div>
		</section>
		<!--/hero_in-->
        <div class="filters_listing sticky_horizontal">
			<div class="container">
				<ul class="clearfix">
					<li>
						<div class="switch-field">
							<input type="radio" id="all" name="listing_filter" value="all" checked data-filter="*" class="selected">
							<label for="all">All</label>
							<input type="radio" id="popular" name="listing_filter" value="popular" data-filter=".popular">
							<label for="popular">Popular</label>
							<input type="radio" id="latest" name="listing_filter" value="latest" data-filter=".latest">
							<label for="latest">Latest</label>
						</div>
					</li>
					<li>
						<div class="layout_view">
							<router-link to="/user-post-grid"><i class="icon-th"></i></router-link>
							<router-link to="/user-post" class="active"><i class="icon-th-list"></i></router-link>
						</div>
					</li>
					<!--<li>
						<a class="btn_map" data-bs-toggle="collapse" href="#collapseMap" aria-expanded="false" aria-controls="collapseMap" data-text-swap="Hide map" data-text-original="View on map">View on map</a>
					</li>-->
				</ul>
			</div>
			<!-- /container -->
		</div>
        <div class="collapse" id="collapseMap">
			<div id="map" class="map"></div>
		</div>
        <div class="container margin_60_35">
			<!--<div class="col-lg-12">
				<div class="row g-0 custom-search-input-2 inner">
					<div class="col-lg-4">
						<div class="form-group">
							<input class="form-control" type="text" placeholder="What are you looking for...">
							<i class="icon_search"></i>
						</div>
					</div>
					<div class="col-lg-3">
						<div class="form-group">
							<input class="form-control" type="text" placeholder="Where">
							<i class="icon_pin_alt"></i>
						</div>
					</div>
					<div class="col-lg-3">
						<select class="wide">
							<option>All Categories</option>	
							<option>Churches</option>
							<option>Historic</option>
							<option>Museums</option>
							<option>Walking tours</option>
						</select>
					</div>
					<div class="col-lg-2">
						<input type="submit" class="btn_search" value="Search">
					</div>
				</div>
				
			</div>-->
			<!-- /custom-search-input-2 -->
			<div class="wrapper-grid">
			<div class="row">
				<div class="col-xl-4 col-lg-6 col-md-6" v-for="lists in list" :key="lists.id">
					<div class="box_grid">
						<figure>
							<a href="#0" class="wish_bt"></a>
							<router-link to="/user-post-single"><img src="../../public/frontend/img/tour_1.jpg" class="img-fluid" alt="" width="800" height="533"><div class="read_more"><span>Read more</span></div></router-link>
							<small>Historic</small>
						</figure>
						<div class="wrapper">
							<h3><router-link to="tour-detail.html">Arc Triomphe</router-link></h3>
							<p>Id placerat tacimates definitionem sea, prima quidam vim no. Duo nobis persecuti cu.</p>
							<span class="price">From <strong>$54</strong> /per person</span>
						</div>
						<ul>
							<li><i class="icon_clock_alt"></i> 1h 30min</li>
							<li><div class="score"><span>Superb<em>350 Reviews</em></span><strong>8.9</strong></div></li>
						</ul>
					</div>
				</div>
                
			</div>
		
			</div>
			<!-- /isotope-wrapper -->
			
			<p class="text-center add_top_30"><a href="#0" class="btn_1 rounded">Load more</a></p>
		
		</div>
        <div class="bg_color_1">
			<div class="container margin_60_35">
				<div class="row">
					<div class="col-md-4">
						<a href="#0" class="boxed_list">
							<i class="pe-7s-help2"></i>
							<h4>Need Help? Contact us</h4>
							<p>Cum appareat maiestatis interpretaris et, et sit.</p>
						</a>
					</div>
					<div class="col-md-4">
						<a href="#0" class="boxed_list">
							<i class="pe-7s-wallet"></i>
							<h4>Payments and Refunds</h4>
							<p>Qui ea nemore eruditi, magna prima possit eu mei.</p>
						</a>
					</div>
					<div class="col-md-4">
						<a href="#0" class="boxed_list">
							<i class="pe-7s-note2"></i>
							<h4>Quality Standards</h4>
							<p>Hinc vituperata sed ut, pro laudem nonumes ex.</p>
						</a>
					</div>
				</div>
				<!-- /row -->
			</div>
			<!-- /container -->
		</div>

		
  </Frontendlayout>
</template>

<script>
import Frontendlayout from "../layouts/Frontendlayout.vue";
import API from "@/services/index";
  /* eslint-disable */
export default {
  data() {
    return {
      name: "Home",
      divId: "home",
      bodyId: "",
	  list: [],
    };
  },
  mounted() {
	  this.getList()
  },
  components: { Frontendlayout },
  methods: {
	  getList(){
		const token = "Bearer " + localStorage.getItem("token");
		 API.get("Postrequirement/getList", {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.list=res.data.data
        })
        .catch((err) => {
          console.log(err.response);
        });
	  }
  },
};
</script>
